import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import PageHeader from '../../header';
import CenterPanel from './centerPanel';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import AccordionSession from './accordion';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import RemoveTagConfirmationModal from './removeTagConfirmationModal';
import AssignTagsModal from './assignTagsModal';
import EditTagValueModal from './editTagValueModal';
import {
  selectOrgUnitId,
  getOrgUnitWithSearchTerm,
  getOrgUnitTags,
  updateOrgUnitTagSearch,
  getAvailableTagsByNetworkId,
} from '../../../../actions/organisation';
import { hideWhenClickAwayOrResize } from '../../../shared/contextualMenu/content';
import { previousPage } from 'actions/navigationBar';

export default function OrgUnitManageTagsContent(props) {
  const dispatch = useDispatch();
  const [fetchingTags, setFetchingTags] = useState(false);

  useEffect(() => {
    window.addEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    window.addEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    let cbForGetOrganisation = () => {
      let cbForGetTags = () => {
        setFetchingTags(false);
      };
      dispatch(getOrgUnitTags(props.id, cbForGetTags));
      dispatch(getAvailableTagsByNetworkId(props.id));
    };

    setFetchingTags(true);

    dispatch(selectOrgUnitId(props.id));
    dispatch(getOrgUnitWithSearchTerm(props.id, cbForGetOrganisation));

    return () => {
      window.removeEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
      window.removeEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    };
  }, []);

  const onSearchTermInputChange = (e) => {
    console.log('orgUnitManageTagsContent.onSearchTermInputChange: ', e);

    if (e.target != undefined) dispatch(updateOrgUnitTagSearch(e.target.value));
    else dispatch(updateOrgUnitTagSearch(e));
  };

  const modals = (
    <div>
      {props.showRemoveTagConfirmationModalInOU && <RemoveTagConfirmationModal orgUnit={props.orgUnit} />}
      {props.showEditTagValueModalInOU && <EditTagValueModal orgUnit={props.orgUnit} />}
    </div>
  );

  const isOrgUnitLoaded = props.orgUnit && props.orgUnit.id > 0;

  const bottomSession = <AccordionSession orgUnit={props.orgUnit} userId={props.userId} />;
  return (
    <div className="main-ui-container waiting-area-view-one new-waiting-area-view-one">
      <Container fluid as={Media} greaterThanOrEqual="computer" className="row">
        <div className="left-hand-side-panel pdrm">
          <div className="relative">
            <PageHeader
              classes="waiting-area-title"
              subHeaderClass="waiting-area-sub-title"
              title={APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle}
              titleColor="color-organisational-unit"
              subHeader={
                props.orgUnit.name
                  ? APP.LANGUAGE.OrganisationalUnitManageTags.PageSubHeaderTitle.replace(
                      '##OrganisationalUnitName##',
                      props.orgUnit.name.trim()
                    )
                  : 'Loading...'
              }
              notRenderLogo={true}
              linkTo={`/organisational-unit/view-all`}
              linkText={APP.LANGUAGE.OrganisationalUnitManageTags.BackToOrgUnitsLinkText}
              linkOnClick={() => {
                dispatch(previousPage(APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle));
              }}
              linkClass="color-organisational-unit text-size-mms"
              showLinkCondition={isOrgUnitLoaded}
            >
              <span>
                <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.TagOrgUnitIcon.default} />
              </span>
            </PageHeader>
          </div>
          <div className="manage-tags-waiting-area-container pdlm pdrm">
            <CenterPanel
              orgUnit={props.orgUnit}
              selectedTagObject={props.selectedTagObject}
              searchTerm={props.searchTerm}
              fetchingTags={fetchingTags}
              onSearchTermInputChange={onSearchTermInputChange}
            />
          </div>
        </div>
        <div className="right-hand-side-panel color-right-hand-side-panel-bg">
          <RightPanelOrTopPanel
            orgUnit={props.orgUnit}
            bottomSession={bottomSession}
            availableTags={props.availableTags}
            fetchingTags={fetchingTags}
          />
        </div>
      </Container>
      <Container fluid as={Media} lessThan="tablet">
        <div className="left-hand-side-panel-mobile">
          <PageHeader
            classes="waiting-area-title"
            subHeaderClass="waiting-area-sub-title"
            title={APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle}
            titleColor="color-organisational-unit"
            subHeader={
              props.orgUnit.name
                ? APP.LANGUAGE.OrganisationalUnitManageTags.PageSubHeaderTitle.replace(
                    '##OrganisationalUnitName##',
                    props.orgUnit.name.trim()
                  )
                : 'Loading...'
            }
            notRenderLogo={true}
            linkTo={'/organisational-unit/view-all'}
            linkText={APP.LANGUAGE.OrganisationalUnitManageTags.BackToOrgUnitsLinkText}
            linkOnClick={() => {
              dispatch(previousPage(APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle));
            }}
            linkClass="color-organisational-unit"
            showLinkCondition={isOrgUnitLoaded}
          >
            <span>
              <img className="ui image  mrrnull fl pdrs header-icon" src={APP.IMAGES.TagOrgUnitIcon.default} />
            </span>
          </PageHeader>
          <div className="right-hand-side-panel-mobile">
            <RightPanelOrTopPanel
              orgUnit={props.orgUnit}
              bottomSession={bottomSession}
              availableTags={props.availableTags}
              fetchingTags={fetchingTags}
            />
          </div>
          <div>
            <CenterPanel
              orgUnit={props.orgUnit}
              selectedTagObject={props.selectedTagObject}
              searchTerm={props.searchTerm}
              fetchingTags={fetchingTags}
              onSearchTermInputChange={onSearchTermInputChange}
              isOnMobileOrTablet={true}
            />
          </div>
          <div className="mrtl right-hand-side-bottom-on-mobile">
            {bottomSession}
            <BottomLogo />
          </div>
        </div>
      </Container>
      {modals}
      {props.showAssignTagsModalInOU && <AssignTagsModal orgUnit={props.orgUnit} />}
    </div>
  );
}

OrgUnitManageTagsContent.propTypes = {
  id: PropTypes.number.isRequired,
  orgUnit: PropTypes.object,
  searchTerm: PropTypes.string,
  showAssignTagsModal: PropTypes.bool,
};
